/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Run_ConflictInputs */

const vi_error_irrigation_run_conflict = /** @type {(inputs: Error_Irrigation_Run_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trùng hoặc sát (dưới 1 phút) một phiên tưới khác của bộ này. Xem danh sách phiên trong Lịch tưới rồi chọn giờ khác.`)
};

/**

* @param {Error_Irrigation_Run_ConflictInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_run_conflict = /** @type {((inputs?: Error_Irrigation_Run_ConflictInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Run_ConflictInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_run_conflict(inputs)
});